<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 11 11"
  >
    <path
      id="Icon_feather-star"
      data-name="Icon feather-star"
      d="M8,3,9.545,6.291,13,6.822l-2.5,2.56L11.09,13,8,11.291,4.91,13,5.5,9.383,3,6.822l3.455-.531Z"
      transform="translate(-2.5 -2.5)"
      fill="#ffb221"
      stroke="#ffb221"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  name: "Star",
  props: {
    data: {
      type: Array,
      default: () => {},
    },
    classStr: {
      type: String | Object,
      default: () => {},
    },
  },
};
</script>